import axios, { AxiosError, AxiosHeaders, AxiosResponseHeaders } from 'axios';
import { LoginFormData } from '../../components/Compounds/Modals/Login';
import { User } from '../../types';

export type LoginResponse =
  | {
      data: User;
      otpRequired: false;
      error: null;
      headers: AxiosResponseHeaders | Partial<AxiosHeaders>;
    }
  | {
      data: null;
      otpRequired: true;
      otpSessionToken: string;
      error: null;
      headers: null;
    }
  | {
      data: null;
      otpRequired: false;
      error: {
        message: string;
      };
      headers: null;
    };

export const loginUser = async (body: LoginFormData): Promise<LoginResponse> => {
  const config = {
    url: 'auth/sign_in',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(body)
  };
  try {
    const { data, headers } = await axios({ ...config, baseURL: `${process.env.REACT_APP_API_SERVER_URL}/` });
    if (data.otp_required) {
      return { data: null, otpRequired: true, otpSessionToken: data.otp_session_token, error: null, headers: null };
    }
    return { data: data.data, otpRequired: false, headers, error: null };
  } catch (error) {
    return {
      data: null,
      otpRequired: false,
      error: {
        message: (error as AxiosError<{ errors: string[] }>)?.response?.data?.errors?.[0] || (error as Error).message
      },
      headers: null
    };
  }
};
